import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import { ContainerType } from '../../../Layout/constants';

import Title, { TitleTypes } from '../../../Title';
import { DynamicContainer } from '../../../Layout/DynamicContainer';
import { LocalizedLink } from '../../../LocalizedLink';

const FooterNavColumn = ({ styles, rules, content, eventId }) => {
    const { title, rows } = content;

    const { formatMessage } = useIntl();

    return (
        <DynamicContainer
            as={ContainerType.NAV}
            extend={rules.extendContainer}
            type={ContainerType.BLOCK}
            columns={3}
            xsColumns={6}
            eventId={eventId}
        >
            <Title extend={rules.extendTitle} as={TitleTypes.H5} type={TitleTypes.H4}>
                <FormattedMessage id={title} />
            </Title>
            {rows.map(row => (
                <DynamicContainer
                    key={JSON.stringify(row)}
                    type={ContainerType.FLEX}
                    extend={{ container: rules.linksRow }}
                >
                    {row.links.map(item => (
                        <div
                            key={item.id}
                            className={getPlausibleClassName(
                                styles.linkWrapper,
                                eventId === 'footer-ackee'
                                    ? AnalyticsEvent.FOOTER_ACKEE_CLICK
                                    : AnalyticsEvent.FOOTER_SERVICES_CLICK,
                                { click_text: item.messageId, click_url: item.link },
                            )}
                        >
                            {item.id === 'whitepaper' || item.id === 'blockchain' ? (
                                <a
                                    target={item.blank && '_blank'}
                                    href={formatMessage({ id: item.link })}
                                    className={styles.link}
                                >
                                    <FormattedMessage id={item.messageId} />
                                </a>
                            ) : (
                                <LocalizedLink extend={{ link: rules.link }} to={item.link} anchor={item.anchor}>
                                    <FormattedMessage id={item.messageId} />
                                </LocalizedLink>
                            )}
                        </div>
                    ))}
                </DynamicContainer>
            ))}
        </DynamicContainer>
    );
};

FooterNavColumn.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    content: PropTypes.shape({
        title: PropTypes.string,
        rows: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
    eventId: PropTypes.string.isRequired,
};

export default FooterNavColumn;
